import React from 'react';
import { Link } from 'react-router-dom';

import './GamesCard.css'

export class GamesCard extends React.Component {

    state = {
        imageFailed: false
    };
    
    getDescription = (name) => {
        var descriptions = {
            wordle: "Strategically guess the secret word using 6 guesses.",
            nonogram: "Select the correct squares in each row and column to fill in the grid.",
            mania: "Hit keys to follow the music.",
            clompyclicker: "Click for points."
        };

        let desc = "";

        if (name === "wordle") {
            desc = descriptions.wordle;
        } else if (name === "nonogram") {
            desc = descriptions.nonogram;
        } else if (name === "mania") {
            desc = descriptions.mania;
        } else if (name === "clompy clicker") {
            desc = descriptions.clompyclicker;
        }

        return desc;
    }

    getLink = (name) => {
        var link = "/" + name;
        link = link.replace(/\s+/g, '');
        return link;
    }

    // This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.

    render() {
        return(
            <>
                <div className="box-shadow games-card">
                    <h3>{this.props.name}</h3>
                    <div className="games-card-image">
                        {this.state.imageFailed ?
                            <span className="games-card-image-fallback" aria-hidden="true">{this.props.name.charAt(0)}</span>
                            :
                            <img src={"/img/" + this.props.name.replace(' ', '') + "_CardImage.png"} alt={this.props.name} onError={() => this.setState({ imageFailed: true })} />
                        }
                    </div>
                    <div className="games-card-body">
                        <p className="card-text">{this.getDescription(this.props.name.toLowerCase())}</p>
                        <div className="games-card-buttons">
                            <Link className="" to={this.getLink(this.props.name.toLowerCase())}>
                                <button type="button" className="btn rounded games-card-btn">Play</button>
                            </Link>
                            <Link className="" to={this.getLink(this.props.name.toLowerCase()) + "/leaderboard"}>
                                <button type="button" className="btn rounded games-card-btn">Scores</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </>
    )}


}